import { apiFetch } from '~/utils/api-fetch/apiFetch';

import { SystemFlags } from '../system-flags.types';

export const flagsEndpoint = `system/flags/v1`;
export const getSystemFlags = async () => {
  const res = await apiFetch<SystemFlags>(flagsEndpoint);
  if (res instanceof Error) {
    throw new Error(`Failed to get flags from ${flagsEndpoint}`);
  }
  return res;
};
